import React from 'react'
import "./color.css"

function GreenW() {
    var x = localStorage.getItem("percentage weight")
    return (
        <div className = "green__background">
            {x == "NaN" ? "null": x} 
        </div>
    )
}

export default GreenW
